import React, { useEffect, useState } from 'react';
import { SxStyle } from '../../../../../types';
import { useStringsContext } from '../../../../../contexts/strings';
import { SquadPlayer } from '../../types';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import TableBody from '@mui/material/TableBody';
import PlayerTabContent from './player-tab-content';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';

interface FilteredData
  extends Pick<SquadPlayer, 'fogisId' | 'smcId' | 'esId' | 'forzasysId' | 'optaId'> {}

const filteredDataKeys: (keyof FilteredData)[] = [
  'fogisId',
  'smcId',
  'esId',
  'forzasysId',
  'optaId',
];

interface DataRowsType {
  key: keyof FilteredData;
  value: FilteredData[keyof FilteredData];
}

const styles: SxStyle = {
  tableRow: (theme) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.shades.p10,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }),
};

interface Props {
  player: SquadPlayer;
  onEditPlayer: () => void;
  season: number;
}
const { REACT_APP_DEFAULT_LEAGUE_SEASON } = process.env;
const CURRENT_YEAR = parseInt(REACT_APP_DEFAULT_LEAGUE_SEASON as string, 10);

const PlayerTabData = ({ player, onEditPlayer, season }: Props) => {
  const { strings } = useStringsContext();
  const [rows, setRows] = useState<DataRowsType[] | null>(null);

  useEffect(() => {
    if (player) {
      const dataRows = filteredDataKeys.map((key) => {
        return { key: key, value: player[key] };
      });
      setRows(dataRows);
    }
  }, [player]);

  if (!rows) {
    return <></>;
  }

  return (
    <PlayerTabContent
      title={strings.squadPlayerTabs.data}
      buttonElement={
        <Button
          variant="contained"
          onClick={onEditPlayer}
          startIcon={<EditIcon />}
          disabled={season !== CURRENT_YEAR}
        >
          {strings.squad.edit}
        </Button>
      }
    >
      <TableBody>
        {rows?.map((row) => (
          <TableRow key={row.key} sx={styles.tableRow}>
            <TableCell width={300}>
              <Typography variant="subtitle2">{strings.squadPlayer[row.key]}</Typography>
            </TableCell>
            <TableCell>
              {row.value || (
                <Typography variant="italic">{strings.squad.missingInformation}</Typography>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </PlayerTabContent>
  );
};

export default PlayerTabData;
